import { useState, useEffect } from "react";
import Select from "react-select";
import { server } from "../../server";
import BusSeatView from "../../components/BusSeatView";
import axios from "axios";
import {
  basicQualificationList,
  classList,
  departmentList,
  designationList,
  masterQualificationList,
  professionalQualificationList,
  sectionList,
} from "../../utils";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function AddStaff() {
  const [transport, setTransport] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [uploading, setUploading] = useState(false);
  const generateStaffId = () => {
    const randomDigits = Math.floor(1000000 + Math.random() * 9000000);
    return `AHR${randomDigits}`;
  };
  const [formData, setFormData] = useState({
    staffId: generateStaffId(),
    session: "2025-26",
    basicDetails: {
      initials: "",
      fullName: "",
      gender: "",
      fathersName: "",
      mothersName: "",
      spouseName: "",
      category: "",
      bloodGroup: "",
      religion: "",
      nationality: "",
      dob: "",
      doj: "",
      maritalStatus: "",
      mobNo: "",
      emailId: "",
      aadharNo: "",
      panNo: "",
      basicQualification: "",
      masterQualification: "",
      professionalQualification: "",
      otherQualification: "",
      correspondenceAddress: "",
      permanentAddress: "",
    },
    leaveDetails: {
      totalCl: "",
      clAvailed: "",
      totalMl: "",
      mlAvailed: "",
    },
    categoryDetails: {
      staffCategory: "",
      teacherType: "",
      classTeacher: "",
      section: "",
      designation: "",
      department: "",
    },
    payrollDetails: {
      basicPay: "",
      gradePay: "",
      vpf: "",
      busDeduction: "",
      esiApplied: "",
      hraApplied: "",
      taAllowanceApplied: "",
      bankAccountNumber: "",
      ifscCode: "",
    },
    pfDetails: {
      pfApplied: "",
      pfAccountNumber: "",
      pfJoiningDate: "",
      uanNumber: "",
      nomineeName: "",
      nomineeRelation: "",
    },
    transportFacility: {},
  });

  const handleUploadStaffImage = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setPreview(URL.createObjectURL(file));
    setUploading(true);

    try {
      const { data } = await axios.post(`${server}/staff_presigned`, {
        fileName: file.name,
      });
      const uploadDetails = data?.["body-json"]?.body?.uploadDetails?.[0];
      if (!uploadDetails?.signedUrl || !uploadDetails?.key) {
        throw new Error("Invalid upload details from server");
      }
      await axios.put(uploadDetails.signedUrl, file, {
        headers: { "Content-Type": file.type },
      });
      setImage(uploadDetails.key);
      setFormData((prev) => ({
        ...prev,
        basicDetails: {
          ...prev.basicDetails,
          staffImage: uploadDetails.key,
        },
      }));
    } catch (error) {
      toast.error("Image Upload Failed", { position: "top-right" });
    } finally {
      setUploading(false);
    }
  };

  const countFilledFields = (obj) => {
    return Object.values(obj).filter(
      (val) => val !== "" && val !== null && val !== undefined,
    ).length;
  };

  const handleNestedChange = (section, name, value) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [name]: value,
      },
    }));
  };

  const handleTransportFacilityChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      let updatedTransportFacility = {
        ...prev.transportFacility,
        [name]: value,
      };

      let selectedBus = null;

      if (name === "busStop") {
        if (!value) {
          updatedTransportFacility.vehicleNo = "";
          updatedTransportFacility.busNumber = "";
        } else {
          const availableVehicles = transport
            .filter((route) => route.stoppage === value)
            .map((route) => route.vehicleNumber);

          const firstVehicle =
            availableVehicles.length > 0 ? availableVehicles[0] : "";
          updatedTransportFacility.vehicleNo = firstVehicle;

          selectedBus = transport.find(
            (route) =>
              route.stoppage === value && route.vehicleNumber === firstVehicle,
          );
        }
      } else if (name === "vehicleNo") {
        updatedTransportFacility.vehicleNo = value;

        selectedBus = transport.find(
          (route) =>
            route.vehicleNumber === value &&
            route.stoppage === prev.transportFacility.busStop,
        );
      }

      if (selectedBus) {
        updatedTransportFacility.busNumber = selectedBus.busNo;
      } else if (name === "vehicleNo" && !value) {
        updatedTransportFacility.busNumber = "";
      }

      return {
        ...prev,
        transportFacility: updatedTransportFacility,
      };
    });
  };

  useEffect(() => {
    axios
      .get(`${server}/getAllBusRoutesMongoDb`, {
        headers: {
          Authorization: `${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        const routes = response.data["body-json"]?.body?.routes;
        if (Array.isArray(routes)) {
          setTransport(routes);
        } else {
          console.error("Invalid data format from API", response.data);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("API Error:", error);
        setLoading(false);
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (uploading) {
      toast.warn("Please Wait, Uploading Image", {
        position: "top-right",
      });
      return;
    }

    try {
      const response = await fetch(`${server}/add_staff_mongodb`, {
        method: "POST",
        headers: {
          Authorization: `${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        toast.success("Staff Added", { position: "top-right" });
        navigate("/staff-directory");
      } else {
        toast.error("Please Try Again", { position: "top-right" });
      }
    } catch (error) {
      toast.error("Please Try Again", { position: "top-right" });
    }
  };

  return (
    <>
      <div id="db-wrapper">
        <main id="page-content">
          <div className="">
            <div class="container-fluid">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-12">
                  <div class="m-3 mt-2 pt-1 d-flex justify-content-between">
                    <div class="d-flex align-items-center mt-2">
                      <span
                        onClick={() => window.history.back()}
                        class="back-button me-3 cursor-pointer"
                      >
                        <i className="bi bi-arrow-left fs-3"></i>
                      </span>
                      <nav aria-label="breadcrumb">
                        <h4 className="m-0 lh-sm">Add Staff</h4>
                        <ol class="breadcrumb pe-3 lh-sm">
                          <li class="breadcrumb-item">
                            <a href="#">Human Resource</a>
                          </li>
                          <li class="breadcrumb-item">
                            <a href="#">Staff Directory</a>
                          </li>
                          <li
                            class="breadcrumb-item active"
                            aria-current="page"
                          >
                            Add Staff
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="container-fluid">
              <div className="row g-2">
                <div className="col-lg-8">
                  <form onSubmit={handleSubmit}>
                    <div class="px-5 py-3 bg-white rounded-4">
                      <div
                        class="accordion accordion-flush"
                        id="accordionExample"
                      >
                        <div id="headingOne">
                          <h3 class="m-0 fs-list">
                            <a
                              href="#"
                              class="d-flex align-items-center text-inherit"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseOne"
                              aria-controls="collapseOne"
                            >
                              <span class="me-auto fs-5">
                                1. Basic Information{" "}
                                <span className="ms-3 text-secondary">
                                  (
                                  {String(
                                    countFilledFields(formData.basicDetails),
                                  ).padStart(2, "0")}
                                  /{Object.keys(formData.basicDetails).length})
                                </span>
                              </span>
                              <div className="d-flex align-items-center">
                                <span class="badge bg-secondary-soft me-3 px-3">
                                  Locked
                                </span>
                                <div class="form-check form-switch me-4">
                                  <input
                                    type="checkbox"
                                    class="form-check-input m-0"
                                    checked
                                  />
                                </div>
                                <span className="collapse-toggle">
                                  <i class="bi bi-chevron-down"></i>
                                </span>
                              </div>
                            </a>
                          </h3>

                          <div
                            id="collapseOne"
                            class="collapse"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="row g-2 mt-2 mb-3">
                              {[
                                {
                                  label: "Initials",
                                  name: "initials",
                                  type: "select",
                                  options: [
                                    "Mr",
                                    "Ms",
                                    "Mrs",
                                    "Acharya",
                                    "Sri",
                                    "Smt",
                                    "Kri",
                                    "Kr",
                                  ],
                                },
                                {
                                  label: "Full Name",
                                  name: "fullName",
                                  type: "text",
                                },
                                {
                                  label: "Gender",
                                  name: "gender",
                                  type: "select",
                                  options: ["Male", "Female"],
                                },
                                {
                                  label: "Father's Name",
                                  name: "fathersName",
                                  type: "text",
                                },
                                {
                                  label: "Mother's Name",
                                  name: "mothersName",
                                  type: "text",
                                },
                                {
                                  label: "Spouse Name",
                                  name: "spouseName",
                                  type: "text",
                                },
                                {
                                  label: "Category",
                                  name: "category",
                                  type: "select",
                                  options: ["General", "OBC", "SC", "ST"],
                                },
                                {
                                  label: "Blood Group",
                                  name: "bloodGroup",
                                  type: "select",
                                  options: [
                                    "A+",
                                    "A-",
                                    "B+",
                                    "B-",
                                    "AB+",
                                    "AB-",
                                    "O+",
                                    "O-",
                                    "NA",
                                  ],
                                },
                                {
                                  label: "Religion",
                                  name: "religion",
                                  type: "select",
                                  options: [
                                    "Hindu",
                                    "Muslim",
                                    "Christian",
                                    "Sikh",
                                    "Other",
                                  ],
                                },
                                {
                                  label: "Nationality",
                                  name: "nationality",
                                  type: "select",
                                  options: ["Indian", "Other"],
                                },
                                {
                                  label: "Date of Birth",
                                  name: "dob",
                                  type: "date",
                                },
                                {
                                  label: "Date of Joining",
                                  name: "doj",
                                  type: "date",
                                },
                                {
                                  label: "Marital Status",
                                  name: "maritalStatus",
                                  type: "select",
                                  options: ["Single", "Married", "Other"],
                                },
                                {
                                  label: "Mobile No.",
                                  name: "mobNo",
                                  type: "text",
                                },
                                {
                                  label: "Email ID",
                                  name: "emailId",
                                  type: "email",
                                },
                                {
                                  label: "Aadhaar No",
                                  name: "aadharNo",
                                  type: "text",
                                },
                                {
                                  label: "PAN No",
                                  name: "panNo",
                                  type: "text",
                                },
                                {
                                  label: "Basic Qualification",
                                  name: "basicQualification",
                                  type: "select",
                                  options: basicQualificationList,
                                },
                                {
                                  label: "Master Qualification",
                                  name: "masterQualification",
                                  type: "select",
                                  options: masterQualificationList,
                                },
                                {
                                  label: "Professional Qualification",
                                  name: "professionalQualification",
                                  type: "select",
                                  options: professionalQualificationList,
                                },
                                {
                                  label: "Other Qualification",
                                  name: "otherQualification",
                                  type: "text",
                                  col: 6,
                                },
                                {
                                  label: "Correspondence Address",
                                  name: "correspondenceAddress",
                                  type: "text",
                                  col: 12,
                                },
                                {
                                  label: "Permanent Address",
                                  name: "permanentAddress",
                                  type: "text",
                                  col: 12,
                                },
                              ].map(
                                ({ label, name, type, options, col = 6 }) => (
                                  <div
                                    className={`col-lg-${col} col-12`}
                                    key={name}
                                  >
                                    <label className="form-label mb-1 ms-3">
                                      {label}{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    {type === "select" ? (
                                      <Select
                                        name={name}
                                        options={options.map((opt) => ({
                                          label: opt,
                                          value: opt,
                                        }))}
                                        value={
                                          formData.basicDetails[name]
                                            ? {
                                                label:
                                                  formData.basicDetails[name],
                                                value:
                                                  formData.basicDetails[name],
                                              }
                                            : null
                                        }
                                        onChange={(selectedOption) =>
                                          handleNestedChange(
                                            "basicDetails",
                                            name,
                                            selectedOption?.value || "",
                                          )
                                        }
                                        placeholder={`Select ${label}`}
                                      />
                                    ) : (
                                      <input
                                        type={type}
                                        className="form-control text-dark"
                                        placeholder={`Enter ${label}`}
                                        name={name}
                                        value={formData.basicDetails[name]}
                                        onChange={(e) =>
                                          handleNestedChange(
                                            "basicDetails",
                                            e.target.name,
                                            e.target.value,
                                          )
                                        }
                                        required
                                      />
                                    )}
                                  </div>
                                ),
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="px-5 py-3 mt-1 bg-white rounded-4">
                      <div
                        class="accordion accordion-flush"
                        id="accordionExample"
                      >
                        <div id="headingTwo">
                          <h3 class="m-0 fs-list">
                            <a
                              href="#"
                              class="d-flex align-items-center text-inherit"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseTwo"
                              aria-controls="collapseTwo"
                            >
                              <span class="me-auto fs-5">
                                2. Leave Details{" "}
                                <span className="ms-3 text-secondary">
                                  (
                                  {String(
                                    countFilledFields(formData.leaveDetails),
                                  ).padStart(2, "0")}
                                  /
                                  {String(
                                    Object.keys(formData.leaveDetails).length,
                                  ).padStart(2, "0")}
                                  )
                                </span>
                              </span>
                              <div className="d-flex align-items-center">
                                <span class="badge bg-secondary-soft me-3 px-3">
                                  Locked
                                </span>
                                <div class="form-check form-switch me-4">
                                  <input
                                    type="checkbox"
                                    class="form-check-input m-0"
                                    checked
                                  />
                                </div>
                                <span className="collapse-toggle">
                                  <i class="bi bi-chevron-down"></i>
                                </span>
                              </div>
                            </a>
                          </h3>

                          <div
                            id="collapseTwo"
                            class="collapse"
                            aria-labelledby="headingTwo"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="row g-2 mt-2 mb-3">
                              {[
                                {
                                  label: "Casual Leave",
                                  name: "totalCl",
                                  type: "number",
                                  required: true,
                                },
                                {
                                  label: "Medical Leave",
                                  name: "totalMl",
                                  type: "number",
                                  required: true,
                                },
                              ].map(
                                ({ label, name, type, options, required }) => (
                                  <div className="col-lg-6 col-12" key={name}>
                                    <label className="form-label mb-1 ms-3">
                                      {label}{" "}
                                      {required && (
                                        <span className="text-danger">*</span>
                                      )}
                                    </label>

                                    {type === "select" ? (
                                      <Select
                                        name={name}
                                        options={options.map((opt) => ({
                                          label: opt,
                                          value: opt,
                                        }))}
                                        value={
                                          formData[name]
                                            ? {
                                                label:
                                                  formData.leaveDetails[name],
                                                value:
                                                  formData.leaveDetails[name],
                                              }
                                            : null
                                        }
                                        onChange={(selectedOption) =>
                                          handleNestedChange(
                                            "leaveDetails",
                                            name,
                                            selectedOption?.value || "",
                                          )
                                        }
                                        placeholder={`Select ${label}`}
                                      />
                                    ) : (
                                      <input
                                        type={type}
                                        className="form-control text-dark"
                                        name={name}
                                        value={formData.leaveDetails[name]}
                                        onChange={(e) =>
                                          handleNestedChange(
                                            "leaveDetails",
                                            e.target.name,
                                            e.target.value,
                                          )
                                        }
                                        placeholder={`Enter ${label}`}
                                        required={required}
                                      />
                                    )}
                                  </div>
                                ),
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="px-5 py-3 mt-1 bg-white rounded-4">
                      <div
                        class="accordion accordion-flush"
                        id="accordionExample"
                      >
                        <div id="headingFive">
                          <h3 class="m-0 fs-list">
                            <a
                              href="#"
                              class="d-flex align-items-center text-inherit"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseFive"
                              aria-controls="collapseFive"
                            >
                              <span class="me-auto fs-5">
                                3. Category Details{" "}
                                <span className="ms-3 text-secondary">
                                  (
                                  {String(
                                    countFilledFields(formData.categoryDetails),
                                  ).padStart(2, "0")}
                                  /
                                  {String(
                                    Object.keys(formData.categoryDetails)
                                      .length,
                                  ).padStart(2, "0")}
                                  )
                                </span>
                              </span>
                              <div className="d-flex align-items-center">
                                <span class="badge bg-secondary-soft me-3 px-3">
                                  Locked
                                </span>
                                <div class="form-check form-switch me-4">
                                  <input
                                    type="checkbox"
                                    class="form-check-input m-0"
                                    checked
                                  />
                                </div>
                                <span className="collapse-toggle">
                                  <i class="bi bi-chevron-down"></i>
                                </span>
                              </div>
                            </a>
                          </h3>

                          <div
                            id="collapseFive"
                            class="collapse"
                            aria-labelledby="headingFive"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="row g-2 mt-2 mb-3">
                              {[
                                {
                                  label: "Staff Category",
                                  name: "staffCategory",
                                  type: "select",
                                  options: [
                                    "Teaching",
                                    "Non Teaching",
                                    "Supporting Staff",
                                  ],
                                  required: true,
                                },
                                {
                                  label: "Teacher Type",
                                  name: "teacherType",
                                  type: "select",
                                  options: [
                                    "TGT",
                                    "PGT",
                                    "PRT",
                                    "PRIMARY TEACHER",
                                    "OTHER",
                                  ],
                                  required: true,
                                },
                                {
                                  label: "Class Teacher",
                                  name: "classTeacher",
                                  type: "select",
                                  options: [
                                    "Not a Class Teacher",
                                    ...classList,
                                  ],
                                },
                                {
                                  label: "Section",
                                  name: "section",
                                  type: "select",
                                  options: sectionList,
                                },
                                {
                                  label: "Designation",
                                  name: "designation",
                                  type: "select",
                                  options: designationList,
                                  required: true,
                                },
                                {
                                  label: "Department",
                                  name: "department",
                                  type: "select",
                                  options: departmentList,
                                  required: true,
                                },
                              ].map(
                                ({ label, name, type, options, required }) => (
                                  <div className="col-lg-6 col-12" key={name}>
                                    <label className="form-label mb-1 ms-3">
                                      {label}{" "}
                                      {required && (
                                        <span className="text-danger">*</span>
                                      )}
                                    </label>

                                    {type === "select" ? (
                                      <Select
                                        name={name}
                                        options={options.map((opt) => ({
                                          label: opt,
                                          value: opt,
                                        }))}
                                        value={
                                          formData.categoryDetails[name]
                                            ? {
                                                label:
                                                  formData.categoryDetails[
                                                    name
                                                  ],
                                                value:
                                                  formData.categoryDetails[
                                                    name
                                                  ],
                                              }
                                            : null
                                        }
                                        onChange={(selectedOption) =>
                                          handleNestedChange(
                                            "categoryDetails",
                                            name,
                                            selectedOption?.value || "",
                                          )
                                        }
                                        placeholder={`Select ${label}`}
                                      />
                                    ) : (
                                      <input
                                        type={type}
                                        className="form-control text-dark"
                                        name={name}
                                        value={
                                          formData.categoryDetails[name] || ""
                                        }
                                        onChange={(e) =>
                                          handleNestedChange(
                                            "categoryDetails",
                                            e.target.name,
                                            e.target.value,
                                          )
                                        }
                                        placeholder={`Enter ${label}`}
                                        required={required}
                                      />
                                    )}
                                  </div>
                                ),
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="px-5 py-3 mt-1 bg-white rounded-4">
                      <div
                        class="accordion accordion-flush"
                        id="accordionExample"
                      >
                        <div id="headingThree">
                          <h3 class="m-0 fs-list">
                            <a
                              href="#"
                              class="d-flex align-items-center text-inherit"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseThree"
                              aria-controls="collapseThree"
                            >
                              <span class="me-auto fs-5">
                                4. Payroll Details{" "}
                                <span className="ms-3 text-secondary">
                                  (
                                  {String(
                                    countFilledFields(formData.payrollDetails),
                                  ).padStart(2, "0")}
                                  /
                                  {String(
                                    Object.keys(formData.payrollDetails).length,
                                  ).padStart(2, "0")}
                                  )
                                </span>
                              </span>
                              <div className="d-flex align-items-center">
                                <span class="badge bg-secondary-soft me-3 px-3">
                                  Locked
                                </span>
                                <div class="form-check form-switch me-4">
                                  <input
                                    type="checkbox"
                                    class="form-check-input m-0"
                                    checked
                                  />
                                </div>
                                <span className="collapse-toggle">
                                  <i class="bi bi-chevron-down"></i>
                                </span>
                              </div>
                            </a>
                          </h3>

                          <div
                            id="collapseThree"
                            class="collapse"
                            aria-labelledby="headingThree"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="row g-2 mt-2 mb-3">
                              {[
                                {
                                  label: "Basic Pay",
                                  name: "basicPay",
                                  type: "number",
                                  required: true,
                                },
                                {
                                  label: "Grade Pay",
                                  name: "gradePay",
                                  type: "number",
                                  required: true,
                                },
                                {
                                  label: "VPF",
                                  name: "vpf",
                                  type: "number",
                                  required: true,
                                },
                                {
                                  label: "Bus Deduction",
                                  name: "busDeduction",
                                  type: "select",
                                  options: ["Yes", "No"],
                                },
                                {
                                  label: "ESI Applied",
                                  name: "esiApplied",
                                  type: "select",
                                  options: ["Yes", "No"],
                                },
                                {
                                  label: "HRA Applied",
                                  name: "hraApplied",
                                  type: "select",
                                  options: ["Yes", "No"],
                                },
                                {
                                  label: "TA Allowance Applied",
                                  name: "taAllowanceApplied",
                                  type: "select",
                                  options: ["Yes", "No"],
                                },
                                {
                                  label: "Bank Account Number",
                                  name: "bankAccountNumber",
                                  type: "text",
                                  required: true,
                                },
                                {
                                  label: "IFSC Code",
                                  name: "ifscCode",
                                  type: "text",
                                  required: true,
                                },
                              ].map(
                                ({ label, name, type, options, required }) => (
                                  <div className="col-lg-6 col-12" key={name}>
                                    <label className="form-label mb-1 ms-3">
                                      {label}{" "}
                                      {required && (
                                        <span className="text-danger">*</span>
                                      )}
                                    </label>

                                    {type === "select" ? (
                                      <Select
                                        name={name}
                                        options={options.map((opt) => ({
                                          label: opt,
                                          value: opt,
                                        }))}
                                        value={
                                          formData.payrollDetails[name]
                                            ? {
                                                label:
                                                  formData.payrollDetails[name],
                                                value:
                                                  formData.payrollDetails[name],
                                              }
                                            : null
                                        }
                                        onChange={(selectedOption) =>
                                          handleNestedChange(
                                            "payrollDetails",
                                            name,
                                            selectedOption?.value || "",
                                          )
                                        }
                                        placeholder={`Select ${label}`}
                                      />
                                    ) : (
                                      <input
                                        type={type}
                                        className="form-control text-dark"
                                        name={name}
                                        value={
                                          formData.payrollDetails[name] || ""
                                        }
                                        onChange={(e) =>
                                          handleNestedChange(
                                            "payrollDetails",
                                            e.target.name,
                                            e.target.value,
                                          )
                                        }
                                        placeholder={`Enter ${label}`}
                                        required={required}
                                      />
                                    )}
                                  </div>
                                ),
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="px-5 py-3 mt-1 bg-white rounded-4">
                      <div
                        class="accordion accordion-flush"
                        id="accordionExample"
                      >
                        <div id="headingFour">
                          <h3 class="m-0 fs-list">
                            <a
                              href="#"
                              class="d-flex align-items-center text-inherit"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseFour"
                              aria-controls="collapseFour"
                            >
                              <span class="me-auto fs-5">
                                5. PF Details{" "}
                                <span className="ms-3 text-secondary">
                                  (
                                  {String(
                                    countFilledFields(formData.pfDetails),
                                  ).padStart(2, "0")}
                                  /
                                  {String(
                                    Object.keys(formData.pfDetails).length,
                                  ).padStart(2, "0")}
                                  )
                                </span>
                              </span>
                              <div className="d-flex align-items-center">
                                <span class="badge bg-secondary-soft me-3 px-3">
                                  Locked
                                </span>
                                <div class="form-check form-switch me-4">
                                  <input
                                    type="checkbox"
                                    class="form-check-input m-0"
                                    checked
                                  />
                                </div>
                                <span className="collapse-toggle">
                                  <i class="bi bi-chevron-down"></i>
                                </span>
                              </div>
                            </a>
                          </h3>

                          <div
                            id="collapseFour"
                            class="collapse"
                            aria-labelledby="headingFour"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="row g-2 mt-2 mb-3">
                              {[
                                {
                                  label: "PF Applied",
                                  name: "pfApplied",
                                  type: "select",
                                  options: ["Yes", "No"],
                                },
                                {
                                  label: "PF A/C No",
                                  name: "pfAccountNumber",
                                  type: "text",
                                  required: true,
                                },
                                {
                                  label: "PF Joining Date",
                                  name: "pfJoiningDate",
                                  type: "date",
                                },
                                {
                                  label: "UAN No",
                                  name: "uanNumber",
                                  type: "text",
                                },
                                {
                                  label: "Nominee Name",
                                  name: "nomineeName",
                                  type: "text",
                                },
                                {
                                  label: "Relation With Nominee",
                                  name: "nomineeRelation",
                                  type: "select",
                                  options: ["Father", "Mother", "Spouse"],
                                },
                              ].map(
                                ({ label, name, type, required, options }) => (
                                  <div className="col-lg-6 col-12" key={name}>
                                    <label className="form-label mb-1 ms-3">
                                      {label}{" "}
                                      {required && (
                                        <span className="text-danger">*</span>
                                      )}
                                    </label>

                                    {type === "select" ? (
                                      <Select
                                        name={name}
                                        options={options.map((opt) => ({
                                          label: opt,
                                          value: opt,
                                        }))}
                                        value={
                                          formData.pfDetails[name]
                                            ? {
                                                label: formData.pfDetails[name],
                                                value: formData.pfDetails[name],
                                              }
                                            : null
                                        }
                                        onChange={(selectedOption) =>
                                          handleNestedChange(
                                            "pfDetails",
                                            name,
                                            selectedOption?.value || "",
                                          )
                                        }
                                        placeholder={`Select ${label}`}
                                      />
                                    ) : (
                                      <input
                                        type={type}
                                        className="form-control text-dark"
                                        name={name}
                                        value={formData.pfDetails[name] || ""}
                                        onChange={(e) =>
                                          handleNestedChange(
                                            "pfDetails",
                                            e.target.name,
                                            e.target.value,
                                          )
                                        }
                                        placeholder={`Enter ${label}`}
                                        required={required}
                                      />
                                    )}
                                  </div>
                                ),
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="px-5 py-3 mt-1 bg-white rounded-4">
                      <div
                        class="accordion accordion-flush"
                        id="accordionExample"
                      >
                        <div id="headingSix">
                          <h3 class="m-0 fs-list">
                            <a
                              href="#"
                              class="d-flex align-items-center text-inherit"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseSix"
                              aria-controls="collapseSix"
                            >
                              <span class="me-auto fs-5">
                                6. Transport Facility{" "}
                                <span className="ms-3 text-secondary">
                                  (
                                  {String(
                                    countFilledFields(
                                      formData.transportFacility,
                                    ),
                                  ).padStart(2, "0")}
                                  /
                                  {String(
                                    Object.keys(formData.transportFacility)
                                      .length,
                                  ).padStart(2, "0")}
                                  )
                                </span>
                              </span>
                              <div className="d-flex align-items-center">
                                <span className="badge me-5 px-3 bg-info-soft">
                                  If Availing
                                </span>
                                <span className="collapse-toggle">
                                  <i class="bi bi-chevron-down"></i>
                                </span>
                              </div>
                            </a>
                          </h3>

                          <div
                            id="collapseSix"
                            class="collapse"
                            aria-labelledby="headingSix"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="row g-2 mt-2 mb-3">
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Bus Stoppage
                                </label>
                                <Select
                                  options={Array.from(
                                    new Set(
                                      transport.map((route) => route.stoppage),
                                    ),
                                  )
                                    .sort((a, b) => a.localeCompare(b))
                                    .map((stoppage) => ({
                                      label: stoppage,
                                      value: stoppage,
                                    }))}
                                  value={
                                    formData.transportFacility.busStop
                                      ? {
                                          label:
                                            formData.transportFacility.busStop,
                                          value:
                                            formData.transportFacility.busStop,
                                        }
                                      : null
                                  }
                                  onChange={(selected) =>
                                    handleTransportFacilityChange({
                                      target: {
                                        name: "busStop",
                                        value: selected?.value || "",
                                      },
                                    })
                                  }
                                  placeholder="Select Bus Stop"
                                  classNamePrefix="react-select"
                                  className="text-dark"
                                  isClearable
                                />
                              </div>

                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Vehicle No.
                                </label>
                                <Select
                                  options={transport
                                    .filter(
                                      (route) =>
                                        route.stoppage ===
                                        formData.transportFacility.busStop,
                                    )
                                    .map((route) => ({
                                      label: route.vehicleNumber,
                                      value: route.vehicleNumber,
                                    }))}
                                  value={
                                    formData.transportFacility.vehicleNo
                                      ? {
                                          label:
                                            formData.transportFacility
                                              .vehicleNo,
                                          value:
                                            formData.transportFacility
                                              .vehicleNo,
                                        }
                                      : null
                                  }
                                  onChange={(selected) =>
                                    handleTransportFacilityChange({
                                      target: {
                                        name: "vehicleNo",
                                        value: selected?.value || "",
                                      },
                                    })
                                  }
                                  placeholder="Select Vehicle Number"
                                  classNamePrefix="react-select"
                                  className="text-dark"
                                  isDisabled={
                                    !formData.transportFacility.busStop
                                  }
                                  isClearable
                                />
                              </div>

                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Bus No.
                                </label>
                                <input
                                  type="number"
                                  className="form-control text-dark"
                                  name="busNumber"
                                  value={
                                    formData.transportFacility.busNumber || ""
                                  }
                                  readOnly
                                />
                              </div>
                            </div>

                            {formData.transportFacility.vehicleNo && (
                              <BusSeatView
                                vehicleNumber={
                                  formData.transportFacility.vehicleNo
                                }
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="my-3 d-flex float-end me-5">
                      <button
                        type="submit"
                        disabled={uploading}
                        class="btn btn-success mt-2 px-6"
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>

                <div className="col-lg-4">
                  <div class="p-5 bg-white rounded-4 sticky-top top-10 z-1">
                    <div className="d-flex flex-column align-items-center">
                      <div>
                        <div class="icon-shape icon-xxl p-7 border rounded-3 position-relative overflow-hidden me-2">
                          {preview ? (
                            <img
                              src={preview}
                              alt="Preview"
                              width="150"
                              height="150"
                              className="object-fit-cover rounded-3"
                            />
                          ) : (
                            <span className="position-absolute mt-2">
                              <i className="bi bi-image fs-2"></i>
                            </span>
                          )}

                          {uploading && (
                            <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-50 rounded-3">
                              <div
                                className="spinner-border text-light"
                                role="status"
                              ></div>
                            </div>
                          )}

                          <input
                            className="form-control border-0 opacity-0 position-absolute top-0 start-0 w-100 h-100"
                            type="file"
                            onChange={handleUploadStaffImage}
                            accept="image/*"
                            disabled={uploading}
                          />
                        </div>
                        <div class="icon-shape icon-xxl p-7 border rounded-3 position-relative">
                          <img
                            src="https://cdn-icons-png.flaticon.com/512/14021/14021384.png"
                            className="w-100 position-absolute p-2 rounded-4"
                            alt="QR"
                          />
                        </div>
                      </div>
                      <div className="mt-4 text-center">
                        <h3 class="m-0 fs-4 lh-sm">
                          {formData?.basicDetails?.fullName || "Full Name"} (
                          {formData?.staffId})
                        </h3>
                        <p className="m-0">
                          {formData?.basicDetails?.doj || "Date of Joining"}
                        </p>
                        <p className="mt-2 mb-0 text-danger lh-sm">
                          (+91) {formData?.basicDetails?.mobNo || "Mobile No"}
                          <br />
                          {formData?.basicDetails?.emailId || "Email ID"}
                        </p>

                        <p className="mt-2 mb-0 text-dark lh-sm">
                          {formData?.basicDetails?.fathersName ||
                            "Father's Name"}
                          <br />
                          {formData?.basicDetails?.mothersName ||
                            "Mother's Name"}
                        </p>

                        <p className="m-0 lh-sm mt-4 text-capitalize">
                          {(
                            formData?.basicDetails?.permanentAddress ||
                            "Permanent Address"
                          )
                            .toLowerCase()
                            .replace(/\b\w/g, (char) => char.toUpperCase())}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default AddStaff;
